<template>
    <div>
        <!-- 桌面端表格布局 -->
        <div class="hidden md:block overflow-x-auto artist-items">
            <table class="table table-pin-rows">
                <thead>
                    <tr>
                        <th class="bg-base-200 font-semibold text-base-content/70">艺术家</th>
                        <th class="bg-base-200 font-semibold text-base-content/70">专辑数</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center">收藏</th>
                        <th class="bg-base-200 font-semibold text-base-content/70 text-center">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" 
                        class="hover:bg-base-200 cursor-pointer transition-colors duration-200 border-b border-base-200/50"
                        @click="redirctDetail(item.id)">
                        <td class="py-4">
                            <div class="flex items-center gap-4">
                                <div class="avatar">
                                    <div class="mask mask-squircle w-16 h-16 tile-img relative overflow-hidden shadow-lg">
                                        <img :src="item.image" v-if="item.image"
                                            alt="Artist Avatar" class="w-full h-full object-cover" />
                                        <img v-else src="/static/dist/img/album_null.jpg" 
                                             class="w-full h-full object-cover opacity-60">
                                        <div class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center play-overlay">
                                            <div class="play-icon opacity-0 hover:opacity-100 transition-opacity duration-300" @click.stop="playNow(item.id)">
                                                <svg class="fill-white w-8 h-8 hover:scale-110 transition-transform duration-200" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="font-bold text-base-content truncate">{{ item.name }}</div>
                                    <div class="text-sm text-base-content/60">{{ item.albumCount }} 张专辑</div>
                                </div>
                            </div>
                        </td>
                        <td class="text-base-content/70">{{ item.albumCount || 0 }}</td>
                        <td class="text-center">
                            <button class="btn btn-ghost btn-sm btn-circle" @click.stop="addFavouriteArtist(item)">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                     :class="['h-5', 'w-5', item.favourite ? 'fill-red-500 text-red-500' : 'fill-none']" 
                                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" 
                                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                            </button>
                        </td>
                        <td class="text-center">
                            <div class="dropdown dropdown-left">
                                <div tabindex="0" role="button" class="btn btn-ghost btn-sm btn-circle" @click.stop>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                    </svg>
                                </div>
                                <ul tabindex="0" class="dropdown-content z-[3] menu p-2 shadow bg-base-100 rounded-box w-52">
                                    <li><a @click.stop="playNow(item.id)">播放全部歌曲</a></li>
                                    <li><a @click.stop="playNext(item.id)">下一首播放</a></li>
                                    <li><a @click.stop="playLater(item.id)">添加到队列</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 移动端卡片布局 -->
        <div class="md:hidden space-y-3">
            <div v-for="(item, index) in items" :key="index" 
                 class="card bg-base-100 shadow-md hover:shadow-lg transition-shadow duration-300 border border-base-200">
                <div class="card-body p-4">
                    <div class="flex items-center gap-4" @click="redirctDetail(item.id)">
                        <div class="avatar flex-shrink-0">
                            <div class="mask mask-squircle w-16 h-16 tile-img relative overflow-hidden">
                                <img :src="item.image" v-if="item.image"
                                    alt="Artist Avatar" class="w-full h-full object-cover" />
                                <img v-else src="/static/dist/img/album_null.jpg" 
                                     class="w-full h-full object-cover opacity-60">
                                <div class="absolute inset-0 bg-black bg-opacity-0 active:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
                                    <div class="play-icon opacity-0 active:opacity-100 transition-opacity duration-200" @click.stop="playNow(item.id)">
                                        <svg class="fill-white w-6 h-6" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 min-w-0">
                            <h3 class="font-bold text-base-content truncate">{{ item.name }}</h3>
                            <p class="text-sm text-base-content/60">{{ item.albumCount }} 张专辑</p>
                        </div>
                        <div class="flex flex-col gap-2 items-center">
                            <!-- 收藏按钮 -->
                            <button class="btn btn-ghost btn-sm btn-circle" @click.stop="addFavouriteArtist(item)">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                     :class="['h-5', 'w-5', item.favourite ? 'fill-red-500 text-red-500' : 'fill-none']" 
                                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" 
                                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                            </button>
                            <!-- 更多操作按钮 -->
                            <div class="dropdown dropdown-left">
                                <div tabindex="0" role="button" class="btn btn-ghost btn-sm btn-circle" @click.stop>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                    </svg>
                                </div>
                                <ul tabindex="0" class="dropdown-content z-[3] menu p-2 shadow bg-base-100 rounded-box w-40">
                                    <li><a @click.stop="playNow(item.id)" class="text-sm">播放全部</a></li>
                                    <li><a @click.stop="playNext(item.id)" class="text-sm">下一首播放</a></li>
                                    <li><a @click.stop="playLater(item.id)" class="text-sm">添加到队列</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!items || items.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
            <div class="text-6xl mb-4">🎤</div>
            <h3 class="text-xl font-semibold text-base-content mb-2">暂无艺术家</h3>
            <p class="text-base-content/60">还没有找到任何艺术家，请稍后再试</p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            items: { type: Array, required: true }
        },
        created() {
        },
        methods: {
            async playNow(id) {
                try {
                    const tracks = await this.$api.subsonic.getTracksByArtist(id)
                    return this.$store.dispatch('playTrackList', {
                        tracks: tracks
                    })
                } catch (error) {
                    console.error('播放艺术家歌曲失败:', error)
                }
            },
            async playNext(id) {
                try {
                    const tracks = await this.$api.subsonic.getTracksByArtist(id)
                    this.$store.commit('setNextInQueue', tracks)
                    this.$myMsg.notify({
                        title: '添加成功！',
                        type: 'success',
                        time: 2000,
                    })
                } catch (error) {
                    console.error('添加到下一首失败:', error)
                }
            },
            async playLater(id) {
                try {
                    const tracks = await this.$api.subsonic.getTracksByArtist(id)
                    this.$store.commit('addToQueue', tracks)
                    this.$myMsg.notify({
                        title: '添加成功！',
                        type: 'success',
                        time: 2000,
                    })
                } catch (error) {
                    console.error('添加到队列失败:', error)
                }
            },
            redirctDetail(id) {
                this.$router.push({ name: 'artist', params: { id: id } })
            },
            addFavouriteArtist(item) {
                const action = item.favourite ? 'removeFavourite' : 'addFavourite'
                this.$api.subsonic[action](item.id, 'artist').then((res) => {
                    item.favourite = !item.favourite
                    this.$myMsg.notify({
                        title: item.favourite ? '已添加到收藏' : '已取消收藏',
                        type: 'success',
                        time: 2000,
                    })
                }).catch(error => {
                    console.error('收藏操作失败:', error)
                    this.$myMsg.notify({
                        title: '操作失败',
                        type: 'error',
                        time: 2000,
                    })
                })
            },
        }
    }
</script>

<style scoped>
.artist-items {
    min-height: 200px;
}

.tile-img {
    position: relative;
}

.play-overlay:hover .play-icon {
    opacity: 1;
}

/* 移动端触摸优化 */
@media (max-width: 768px) {
    .tile-img:active .play-icon {
        opacity: 1;
    }
    
    .card {
        transition: transform 0.2s ease;
    }
    
    .card:active {
        transform: scale(0.98);
    }
}

/* 桌面端hover效果 */
@media (min-width: 769px) {
    .tile-img:hover .play-overlay {
        background-color: rgba(0, 0, 0, 0.3);
    }
    
    .tile-img:hover .play-icon {
        opacity: 1;
    }
}

/* 滚动条样式 */
.artist-items::-webkit-scrollbar {
    height: 6px;
}

.artist-items::-webkit-scrollbar-track {
    background: hsl(var(--b2));
    border-radius: 3px;
}

.artist-items::-webkit-scrollbar-thumb {
    background: hsl(var(--bc) / 0.2);
    border-radius: 3px;
}

.artist-items::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--bc) / 0.3);
}
</style>
